export default __webpack_public_path__ + "static/media/9.78ddac4f.png";